import * as types from "./types";
import { requestAuth } from "../helpers/FetchApi";
import appSettings from "../AppSettings";
import strings from "../helpers/Localization";
import { ActionsCreators } from "../actions";

export const actionCreators = {
    CreateTag: (value, entityId, entityType, onSuccess) => async (dispatch, store) => {
        const obj = {
            id: 0,
            value: value,
            entityId: entityId,
            entityType: entityType
        };
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/Create", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    CreateMultipleTag: (values, entityId, entityType, onSuccess) => async (dispatch, store) => {
        if (!values || values.length === 0 ) {return onSuccess();}
        const obj = [];
        values.forEach(value => {
            obj.push({
                id: 0,
                value: value,
                entityId: entityId,
                entityType: entityType
            });
        });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/CreateMultiple", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then(() => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    AddTag: (tag, entityId, entityType, onSuccess) => async (dispatch, store) => {
        const obj = {
            id: tag.id,
            value: tag.value,
            entityId: entityId,
            entityType: entityType
        };
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/Add", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    AddMultipleTag: (tags, entityId, entityType, onSuccess) => async (dispatch, store) => {
        if (!tags || tags.length === 0 ) {return onSuccess();}
        const obj = [];
        tags.forEach(tag => {
            obj.push({
                id: tag.id,
                value: tag.value,
                entityId: entityId,
                entityType: entityType
            });
        });
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/AddMultiple", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then(() => {
            onSuccess();
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    RemoveTag: (tag, entityId, entityType, onSuccess) => (dispatch, store) => {
        dispatch(ActionsCreators.RemoveTagIncrement([tag], 0, entityId, entityType, onSuccess));
    },

    RemoveMultipleTags: (tags, entityId, entityType, onSuccess) => (dispatch, store) => {
        if (!tags || tags.length === 0 ) {return onSuccess();}
        dispatch(ActionsCreators.RemoveTagIncrement(tags, 0, entityId, entityType, onSuccess));
    },
    RemoveTagIncrement: (tags, index, entityId, entityType, onEnd) => async (dispatch, store) => {
        const tag = tags[index];
        const obj = {
            id: tag.id,
            value: tag.value,
            entityId: entityId,
            entityType: entityType
        };

        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/Remove", {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then((data) => {
            if (index + 1 === tags.length) {
                onEnd(data);
            }
            else {
                dispatch(ActionsCreators.RemoveTagIncrement(tags, index + 1, entityId, entityType, onEnd));
            }
        }).catch( (data) => {
            console.log("error", data);
        });
    },

    GetElementTags: (entityId, entityType, onSuccess) => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/List/" + entityId + "/" + entityType, {
            method: "GET"
        }).then((data) => {
            onSuccess(data);
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetAllTags: () => async (dispatch, store) => {
        await requestAuth(appSettings.SKALINKAPIURL + "/api/Tag/" + store().currentuser.currentorganization.id, {
            method: "GET"
        }).then((data) => {
            return dispatch({ type: types.GET_TAGS_COMPLETED, assets: data });
        }).catch( (data) => {
            console.log(data);
        });
    },

    GetBestTags: (onSuccess) => (dispatch, store) => {
        ////A FAIRE
        onSuccess([]);

    },

    TagSearch: (obj, entityType, onSuccess) => async (dispatch, store) => {

        function GetPermissions(array) {
            let accessLevel = 0;
            array.forEach((el) => {
                accessLevel = Math.max(el.accessLevelId, accessLevel);
            });
            return accessLevel;
        }

        let URL = appSettings.SKALINKAPIURL + "/api/Tag/Search";
        if (entityType) {URL += "/" + entityType;}

        await requestAuth(URL, {
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(obj),
            method: "POST"
        }).then((data) => {
            const result = [];

            data.forEach((el) => {
                const newObj = {};
                if (el.composition) {
                    newObj.entityType = "composition";
                    newObj.typeName = strings.tagsComposition;
                    newObj.infos = el.composition.width + "x" + el.composition.height;
                    newObj.name = el.composition.name;
                    newObj.id = el.composition.id;

                    newObj.userAccessLevel = GetPermissions(el.compositionPermissions);
                    newObj.composition = el.composition;
                }
                else if (el.content) {
                    newObj.entityType = "content";
                    newObj.typeName = strings.tagsContent;
                    newObj.name = el.content.name;
                    newObj.id = el.content.id;

                    newObj.userAccessLevel = GetPermissions(el.contentPermissions);
                    newObj.content = el.content;
                }
                else if (el.playlist) {
                    newObj.entityType = "playlist";
                    newObj.typeName = strings.tagsPlaylist;
                    newObj.name = el.playlist.name;
                    newObj.id = el.playlist.id;

                    newObj.userAccessLevel = GetPermissions(el.playlistPermissions);
                    newObj.playlist = el.playlist;
                }
                else if (el.schedule) {
                    newObj.entityType = "schedule";
                    newObj.typeName = strings.tagsSchedule;
                    newObj.infos = el.schedule.advancedSchedulingData ? strings.tagsAdvanced : strings.tagsBasic;
                    newObj.name = el.schedule.name;
                    newObj.id = el.schedule.id;

                    newObj.userAccessLevel = GetPermissions(el.schedulePermissions);
                    newObj.schedule = el.schedule;
                }

                result.push(newObj);
            });
            onSuccess(result);
        }).catch( (data) => {
            console.log("error", data);
        });

    }
};
